/**
 * Centralised URL builders for chat navigation.
 *
 * Mirrors ads-iq/frontend/src/utils/urls.ts so the floating widget and the
 * full-page chat agree on one canonical route shape.
 *
 * // retention adaptation: retention-iq has NO platform dimension (Klaviyo
 * // only), so the route is /brand/:slug/chat — not ads-iq's
 * // /brand/:slug/:platform/chat. No market segment either (ads-iq's amazon
 * // market-as-first-class has no equivalent here; region is threaded through
 * // the SSE body via useRegion, not the URL).
 */

/** Full-page chat route for a brand. */
export function chatUrl(brandSlug: string): string {
  return `/brand/${brandSlug}/chat`;
}

/**
 * Embedded chat URL — identical to chatUrl + ?embedded=1. Embedded mode hides
 * the conversation-list sidebar + page header so the chat fills the narrow
 * FloatingChat widget panel. Mirrors ads-iq's chatEmbeddedUrl.
 */
export function chatEmbeddedUrl(brandSlug: string): string {
  return `${chatUrl(brandSlug)}?embedded=1`;
}

/**
 * Embedded chat URL carrying a seed prompt. The embedded Chat auto-sends the
 * seed on a fresh chat (see Chat.tsx seed-prompt handoff). Used by the
 * FloatingChat widget when a "Get advice" entry point (Subjects / Promotions)
 * dispatches a `retention:open-chat` event. Mirrors ads-iq's chatSeedUrl.
 */
export function chatEmbeddedSeedUrl(brandSlug: string, seedPrompt: string): string {
  return `${chatEmbeddedUrl(brandSlug)}&seed_prompt=${encodeURIComponent(seedPrompt)}`;
}
